import {Card, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	padding: 16px;
	border-radius: 8px;
`;
